import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import AppStoreLightLargeSVG from '../icons/appStoreLightLargeSVG'

const Cta = ({ appStoreLink }) => {
  return (
    <section id="cta">
      <div className="flex flex-col items-center layout-space md:flex-row-reverse">
        <div className="w-full mb-6 md:w-3/5 md:mb-0 md:py-8">
          <div className="max-w-2xl pt-12 text-center md:pt-0 md:pl-8">
            <h2 className="mb-4 text-white heading">
              Laden Sie unsere Diktier-App herunter und transkribieren Sie 30 Minuten gratis!
            </h2>
            <p className="mb-8 text-white sub-heading">
              Erhalten Sie 30 Minuten der Sprache-zu-Text-Funktionalitäten kostenlos, wenn Sie sich registrieren.
            </p>
            <a href={appStoreLink} target="_blank" rel="noreferrer">
              <AppStoreLightLargeSVG className="mx-auto app-store-link" />
            </a>
          </div>
        </div>
        <div
          // className="relative flex-shrink-0"
          // style={{ width: '320px', height: '400px' }}
          className="w-full mr-8 md:w-2/5 md:pt-8 "
        >
          <StaticImage
            src="../images/devices-group.png"
            className="w-full"
            alt="VoxRec on iOS"
          />
        </div>
      </div>
    </section>
  )
}

export default Cta
